import Control from './components/Control'
import Header from './components/Header'
import Preview from './components/Preview'
import css from './mediaPreview.module.css'
import { IMediaPreviewCtrl } from './mediaPreview.types.ts'
import { createPortal } from 'react-dom'

interface IProps {
  mediaCtrl: IMediaPreviewCtrl
}

const MediaPreview = ({ mediaCtrl }: IProps) => {
  const body = document.getElementsByTagName('body')[0]

  return createPortal(
    <div className={css.wrapper}>
      <Header media={mediaCtrl.currentMedia} onClose={mediaCtrl.close} />
      <div className={css.contentWrapper}>
        <Control onClick={mediaCtrl.prev} prev={true} disabled={!mediaCtrl.canBack} />
        <Preview key={mediaCtrl.currentMedia.id} media={mediaCtrl.currentMedia} loader={mediaCtrl.loader} />
        <Control onClick={mediaCtrl.next} disabled={!mediaCtrl.canNext} />
      </div>
    </div>,
    body
  )
}

export default MediaPreview
